(function () {
'use strict';
var cfgEl = document.getElementById('km-config');
if (!cfgEl) return;
var CFG;
try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
CFG.ship = CFG.ship || { threshold: 0, fee: 0 };
CFG.mm = CFG.mm || { on: false, tiers: [], ids: [] };
CFG.mm.tiers = (CFG.mm.tiers || []).filter(function (t) { return t.q > 0 && t.p > 0; }).sort(function (a, b) { return a.q - b.q; });
if (!CFG.mm.tiers.length) CFG.mm.on = false;
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
function $(s, c) { return (c || document).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function money(cents) {
cents = Math.round(cents);
var frac = cents % 100 !== 0;
return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: frac ? 2 : 0, maximumFractionDigits: 2 });
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
});
}
function sized(url, w) {
if (!url) return '';
return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}
function cleanTitle(t) { return String(t || '').replace(/^Kalimannu\s*[-–]?\s*/i, ''); }
function plural(n, one, many) { return n === 1 ? one : many; }
function json(url, opts) {
return fetch(url, opts).then(function (r) {
return r.json().then(function (d) {
if (!r.ok) {
var err = new Error(d.description || d.message || 'Something went wrong. Please try again.');
err.data = d;
throw err;
}
return d;
});
});
}
var JSON_HEAD = { 'Content-Type': 'application/json', Accept: 'application/json' };
var toastEl;
function toast(msg) {
if (!toastEl) {
toastEl = document.createElement('div');
toastEl.className = 'km-toast';
toastEl.setAttribute('role', 'status');
document.body.appendChild(toastEl);
}
toastEl.textContent = msg;
toastEl.classList.add('is-on');
clearTimeout(toast.t);
toast.t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3400);
}
var lastFocus = null;
function openD(el) {
if (!el || el.classList.contains('is-open')) return;
lastFocus = document.activeElement;
el.classList.add('is-open');
el.setAttribute('aria-hidden', 'false');
document.documentElement.classList.add('km-lock');
var f = el.querySelector('[data-km-close]:not(.km-drawer__scrim)');
if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
}
function closeD(el) {
if (!el || !el.classList.contains('is-open')) return;
el.classList.remove('is-open');
el.setAttribute('aria-hidden', 'true');
if (!$('.km-drawer.is-open')) document.documentElement.classList.remove('km-lock');
if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
}
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape') return;
var open = $$('.km-drawer.is-open').pop();
if (open) closeD(open);
});
var Cart = {
data: null,
get: function () {
return json(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { Cart.data = c; return c; });
},
add: function (items) {
return json(root + 'cart/add.js', { method: 'POST', headers: JSON_HEAD, body: JSON.stringify({ items: items }) }).then(Cart.get);
},
change: function (key, qty) {
return json(root + 'cart/change.js', { method: 'POST', headers: JSON_HEAD, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (c) { Cart.data = c; return c; });
}
};
var elCart = $('#km-cart');
var onCartPage = !!$('[data-km-cart-page]');
function mmQty(c) {
var ids = CFG.mm.ids || [];
return c.items.reduce(function (n, i) { return n + (ids.indexOf(i.product_id) > -1 ? i.quantity : 0); }, 0);
}
function tierFor(n) {
var cur = null, next = null;
CFG.mm.tiers.forEach(function (t) { if (n >= t.q) cur = t; else if (!next) next = t; });
return { cur: cur, next: next };
}
function barsHtml(c) {
var h = '';
var th = CFG.ship.threshold;
if (th > 0) {
var left = th - c.total_price;
var pct = Math.max(5, Math.min(100, (c.total_price / th) * 100));
h += '<div class="km-meter"><div class="km-meter__t">' +
(left > 0 ? 'Add <b>' + money(left) + '</b> more for free delivery' : 'You have <b>free delivery</b>') +
'</div><div class="km-meter__bar"><i style="width:' + pct + '%"></i></div></div>';
}
if (CFG.mm.on) {
var q = mmQty(c), t = tierFor(q), msg, p;
if (t.next) {
var need = t.next.q - q;
msg = (t.cur ? '<b>' + t.cur.p + '% off</b> your clay cookware. ' : '') +
'Add <b>' + need + ' more</b> clay ' + plural(need, 'item', 'items') + ' to save <b>' + t.next.p + '%</b>';
p = (q / t.next.q) * 100;
} else {
msg = 'Mix and match: <b>' + t.cur.p + '% off</b> your clay cookware';
p = 100;
}
h += '<div class="km-meter km-meter--mm"><div class="km-meter__t">' + msg + '</div><div class="km-meter__bar"><i style="width:' + Math.max(5, p) + '%"></i></div></div>';
}
return h ? '<div class="km-cart__bars">' + h + '</div>' : '';
}
function linesHtml(c) {
return '<ul class="km-lines">' + c.items.map(function (i) {
var disc = (i.line_level_discount_allocations || []).map(function (d) {
return esc(d.discount_application && d.discount_application.title);
}).filter(Boolean).join(', ');
var v = (i.variant_title && i.variant_title !== 'Default Title') ? '<div class="km-line__v">' + esc(i.variant_title) + '</div>' : '';
return '<li class="km-line" data-key="' + esc(i.key) + '">' +
'<a class="km-line__img" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' +
(i.image ? '<img src="' + esc(sized(i.image, 160)) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
'<div><a class="km-line__t" href="' + esc(i.url) + '">' + esc(cleanTitle(i.product_title)) + '</a>' + v +
(disc ? '<div class="km-line__disc">' + disc + '</div>' : '') +
'<div class="km-line__row"><div class="km-qty km-qty--s">' +
'<button type="button" data-km-q="-1" aria-label="Decrease quantity">&minus;</button>' +
'<input type="number" inputmode="numeric" min="0" value="' + i.quantity + '" aria-label="Quantity" data-km-qi>' +
'<button type="button" data-km-q="1" aria-label="Increase quantity">+</button></div>' +
'<div class="km-line__price">' + (i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '') + money(i.final_line_price) + '</div></div>' +
'<button type="button" class="km-line__rm" data-km-rm>Remove</button></div></li>';
}).join('') + '</ul>';
}
function discountNames(c) {
var names = [];
(c.cart_level_discount_applications || []).forEach(function (d) { if (d.title && names.indexOf(d.title) < 0) names.push(d.title); });
c.items.forEach(function (i) {
(i.line_level_discount_allocations || []).forEach(function (d) {
var t = d.discount_application && d.discount_application.title;
if (t && names.indexOf(t) < 0) names.push(t);
});
});
return names.length ? names.join(', ') : 'Discount';
}
function totalsHtml(c) {
var th = CFG.ship.threshold, fee = CFG.ship.fee, free = c.total_price >= th;
var showShip = th > 0 && c.requires_shipping !== false;
var h = '<div class="km-totals"><div><span>Subtotal</span><span>' + money(c.original_total_price) + '</span></div>';
if (c.total_discount > 0) h += '<div class="is-save"><span>' + esc(discountNames(c)) + '</span><span>&minus;' + money(c.total_discount) + '</span></div>';
if (showShip) h += '<div><span>Delivery in India</span><span>' + (free ? 'Free' : money(fee)) + '</span></div>';
h += '<div class="is-total"><span>To pay</span><span>' + money(c.total_price + (showShip && !free ? fee : 0)) + '</span></div></div>';
return h;
}
function emptyHtml() {
return '<div class="km-cart__empty"><h3>Your cart is empty</h3><p>Clay pots, kadai, appam chatti and curd pots, made by hand.</p>' +
'<a class="km-btn km-btn--ink" href="' + esc(CFG.shopUrl || root + 'collections/all') + '">Shop clay cookware</a></div>';
}
function render(c) {
c = c || Cart.data;
if (!c) return;
$$('[data-km-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); });
var has = c.item_count > 0;
$$('[data-km-cart-body]').forEach(function (b) {
b.innerHTML = has ? barsHtml(c) + linesHtml(c) + '<div class="km-cart__ups" data-km-ups hidden></div>' : emptyHtml();
});
$$('[data-km-cart-totals]').forEach(function (t) { t.innerHTML = has ? totalsHtml(c) : ''; });
$$('[data-km-cart-foot]').forEach(function (f) { f.hidden = !has; });
if (has) renderUps();
}
var catalog = null, catalogLoading = null;
function loadCatalog() {
if (catalog) return Promise.resolve(catalog);
if (catalogLoading) return catalogLoading;
if (!CFG.mm.handle) return Promise.resolve([]);
catalogLoading = json(root + 'collections/' + CFG.mm.handle + '/products.json?limit=40')
.then(function (d) { catalog = d.products || []; return catalog; })
.catch(function () { catalog = []; return catalog; });
return catalogLoading;
}
function renderUps() {
var slots = $$('[data-km-ups]');
if (!slots.length || !Cart.data) return;
loadCatalog().then(function (list) {
if (!Cart.data) return;
var inCart = Cart.data.items.map(function (i) { return i.product_id; });
var picks = list.filter(function (p) {
return inCart.indexOf(p.id) < 0 && p.variants.some(function (v) { return v.available; });
}).slice(0, 8);
if (!picks.length) return;
var title = 'Goes well with your order';
if (CFG.mm.on) {
var t = tierFor(mmQty(Cart.data));
if (t.next) title = 'Add a pot and save ' + t.next.p + '%';
}
var html = '<h3>' + esc(title) + '</h3><div class="km-ups">' + picks.map(function (p) {
var avail = p.variants.filter(function (v) { return v.available; });
var min = avail.reduce(function (m, v) { return Math.min(m, parseFloat(v.price)); }, Infinity);
var single = p.variants.length === 1;
var src = p.images && p.images[0] && p.images[0].src;
return '<div class="km-up"><a class="km-up__img" href="' + root + 'products/' + esc(p.handle) + '" tabindex="-1" aria-hidden="true">' +
(src ? '<img src="' + esc(sized(src, 260)) + '" alt="" loading="lazy" width="132" height="132">' : '') + '</a>' +
'<div class="km-up__b"><span class="km-up__t">' + esc(cleanTitle(p.title)) + '</span><span class="km-up__p">' + (single ? '' : 'From ') + money(min * 100) + '</span></div>' +
(single
? '<button type="button" data-km-up-add="' + avail[0].id + '">Add</button>'
: '<button type="button" data-km-quick="' + esc(p.handle) + '">Choose size</button>') + '</div>';
}).join('') + '</div>';
slots.forEach(function (s) { s.innerHTML = html; s.hidden = false; });
});
}
function openCart(skipFetch) {
if (onCartPage) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
else openD(elCart);
if (!skipFetch) Cart.get().then(render).catch(function () {});
}
function goCheckout() {
var b = $('button[name="checkout"]');
if (b) b.click(); else window.location.href = root + 'checkout';
}
function addItems(items, btn, buyNow) {
if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
return Cart.add(items).then(function (c) {
render(c);
if (buyNow) { goCheckout(); return; }
closeD($('#km-sheet'));
openCart(true);
}).catch(function (err) { toast(err.message); }).then(function () {
if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
});
}
document.addEventListener('submit', function (e) {
var f = e.target;
if (!f || !f.matches || !f.matches('form[data-km-add]')) return;
e.preventDefault();
var fd = new FormData(f);
var id = fd.get('id');
if (!id) { toast('Please choose an option first.'); return; }
var q = parseInt(fd.get('quantity') || '1', 10) || 1;
var btn = e.submitter || f.querySelector('[type="submit"]');
addItems([{ id: Number(id), quantity: q }], btn, !!(btn && btn.hasAttribute('data-km-buynow')));
});
function lineChange(li, qty) {
if (!li || li.classList.contains('is-busy')) return;
li.classList.add('is-busy');
Cart.change(li.getAttribute('data-key'), Math.max(0, qty)).then(render).catch(function (err) {
toast(err.message);
Cart.get().then(render);
});
}
function openSheet(handle) {
var sh = $('#km-sheet');
if (!sh) { window.location.href = root + 'products/' + handle; return; }
var body = $('[data-km-sheet-body]', sh);
body.innerHTML = '<p class="km-sheet__load">Loading options</p>';
openD(sh);
json(root + 'products/' + handle + '.js').then(function (p) {
var avail = p.variants.filter(function (v) { return v.available; });
var first = avail[0] || p.variants[0];
var optName = p.options.map(function (o) { return (o.name || o).toString().toLowerCase(); }).join(' and ');
body.innerHTML = '<div class="km-sheet__top">' +
(p.featured_image ? '<img src="' + esc(sized(p.featured_image, 160)) + '" alt="" width="64" height="64">' : '') +
'<div><div class="km-sheet__t">' + esc(cleanTitle(p.title)) + '</div><a class="km-sheet__link" href="' + root + 'products/' + esc(p.handle) + '">View full details</a></div></div>' +
'<form data-km-add method="post" action="' + root + 'cart/add"><div class="km-opt__name km-sheet__lbl">Choose ' + esc(optName) + '</div><div class="km-pills">' +
p.variants.map(function (v) {
return '<label class="km-pill' + (v.available ? '' : ' is-out') + '"><input type="radio" name="id" value="' + v.id + '"' +
(v.id === first.id && v.available ? ' checked' : '') + (v.available ? '' : ' disabled') + '><span>' + esc(v.title) + '<small>' + (v.available ? money(v.price) : 'Sold out') + '</small></span></label>';
}).join('') + '</div><button type="submit" class="km-btn km-btn--brand km-btn--block km-sheet__add"' + (avail.length ? '' : ' disabled') + '>' + (avail.length ? 'Add to cart' : 'Sold out') + '</button></form>';
}).catch(function () { window.location.href = root + 'products/' + handle; });
}
document.addEventListener('click', function (e) {
var t = e.target;
var el;
if ((el = t.closest('[data-km-close]'))) { e.preventDefault(); closeD(el.closest('.km-drawer')); return; }
if ((el = t.closest('[data-km-open]'))) {
var id = el.getAttribute('data-km-open');
if (id === 'km-cart') {
if (onCartPage) return;
e.preventDefault(); openCart(); return;
}
var target = document.getElementById(id);
if (target) { e.preventDefault(); openD(target); }
return;
}
if ((el = t.closest('[data-km-quick]'))) { e.preventDefault(); openSheet(el.getAttribute('data-km-quick')); return; }
if ((el = t.closest('[data-km-up-add]'))) { e.preventDefault(); addItems([{ id: Number(el.getAttribute('data-km-up-add')), quantity: 1 }], el, false); return; }
if ((el = t.closest('[data-km-q]'))) {
var li = el.closest('.km-line');
var input = li && li.querySelector('[data-km-qi]');
if (input) lineChange(li, (parseInt(input.value, 10) || 0) + Number(el.getAttribute('data-km-q')));
return;
}
if ((el = t.closest('[data-km-rm]'))) { lineChange(el.closest('.km-line'), 0); return; }
if ((el = t.closest('[data-km-step]'))) {
var inp = el.parentNode.querySelector('input');
if (inp) {
var val = (parseInt(inp.value, 10) || 1) + Number(el.getAttribute('data-km-step'));
inp.value = Math.max(1, Math.min(99, val));
}
return;
}
if ((el = t.closest('[data-km-search-toggle]'))) {
e.preventDefault();
var panel = $('#km-search');
if (!panel) return;
var on = panel.classList.toggle('is-open');
el.setAttribute('aria-expanded', on ? 'true' : 'false');
if (on) { var si = panel.querySelector('input[type="search"]'); if (si) si.focus(); }
return;
}
if ((el = t.closest('[data-km-scroll]'))) {
var dest = document.querySelector(el.getAttribute('data-km-scroll'));
if (dest) {
e.preventDefault();
if (dest.tagName === 'DETAILS') dest.open = true;
dest.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
return;
}
if ((el = t.closest('[data-km-dot]'))) {
var track = el.closest('.km-gallery').querySelector('.km-gallery__track');
track.scrollTo({ left: Number(el.getAttribute('data-km-dot')) * track.clientWidth, behavior: 'smooth' });
}
});
document.addEventListener('change', function (e) {
var t = e.target;
if (t.matches && t.matches('[data-km-qi]')) { lineChange(t.closest('.km-line'), parseInt(t.value, 10) || 0); return; }
if (t.matches && t.matches('[data-km-sort]')) {
var u = new URL(window.location.href);
u.searchParams.set('sort_by', t.value);
u.searchParams.delete('page');
window.location.href = u.toString();
}
});
function tierText() {
return CFG.mm.tiers.map(function (t, i) {
var last = i === CFG.mm.tiers.length - 1;
return 'any ' + t.q + (last ? ' or more' : '') + ' for ' + t.p + '% off';
}).join(', ');
}
function initMixMatch() {
$$('[data-km-mm-only]').forEach(function (n) { n.hidden = !CFG.mm.on; });
if (!CFG.mm.on) return;
$$('[data-km-mm-tiers]').forEach(function (ul) {
ul.innerHTML = CFG.mm.tiers.map(function (t, i) {
var last = i === CFG.mm.tiers.length - 1;
return '<li class="km-tier" data-km-tier="' + t.q + '"><b>' + t.p + '% off</b>any ' + t.q + (last ? ' or more' : '') + '</li>';
}).join('');
});
$$('[data-km-mm-nudge]').forEach(function (a) {
var pid = Number(a.getAttribute('data-pid'));
if (CFG.mm.ids.indexOf(pid) < 0) return;
var txt = a.querySelector('[data-km-mm-text]');
if (txt) txt.innerHTML = '<b>Mix and match clay cookware:</b> ' + esc(tierText()) + '.';
if (CFG.mm.url) a.setAttribute('href', CFG.mm.url);
a.hidden = false;
});
$$('[data-km-mm-text-only]').forEach(function (n) { n.textContent = tierText(); });
}
function initProduct() {
var pdp = $('[data-km-pdp]');
if (!pdp) return;
var vEl = $('[data-km-variants]', pdp);
var form = $('form[data-km-add]', pdp);
if (!vEl || !form) return;
var variants = JSON.parse(vEl.textContent || '[]');
var sets = $$('[data-km-opt]', pdp);
var atc = $('[data-km-atc]', pdp), buy = $('[data-km-buynow]', pdp);
var track = $('.km-gallery__track', pdp);
function chosen() { return sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
function match(opts) {
return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
}
function setLabel(btn, text) { var s = btn && btn.querySelector('[data-km-label]'); if (s) s.textContent = text; else if (btn) btn.textContent = text; }
function update(pushUrl) {
var opts = chosen();
var v = sets.length ? match(opts) : variants[0];
sets.forEach(function (fs, i) {
$$('input', fs).forEach(function (inp) {
var ok = variants.some(function (x) {
return x.available && x.options[i] === inp.value && x.options.every(function (o, j) { return j === i || o === opts[j]; });
});
inp.parentNode.classList.toggle('is-out', !ok);
});
var cur = fs.querySelector('[data-km-opt-value]');
if (cur) cur.textContent = opts[i] || '';
});
if (!v) {
if (atc) { atc.disabled = true; setLabel(atc, 'Unavailable'); }
if (buy) buy.disabled = true;
return;
}
form.querySelector('[name="id"]').value = v.id;
$$('[data-km-now]').forEach(function (n) { n.textContent = money(v.price); });
var was = $('[data-km-was]', pdp), save = $('[data-km-save]', pdp);
var onSale = v.compare_at_price > v.price;
if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(v.compare_at_price); }
if (save) { save.hidden = !onSale; if (onSale) save.textContent = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '% off'; }
if (atc) { atc.disabled = !v.available; setLabel(atc, v.available ? 'Add to cart' : 'Sold out'); }
if (buy) buy.disabled = !v.available;
$$('[data-km-proxy]').forEach(function (b) { b.disabled = !v.available; });
if (pushUrl) {
if (track && v.media > 0) track.scrollTo({ left: (v.media - 1) * track.clientWidth, behavior: 'smooth' });
try {
var u = new URL(window.location.href);
u.searchParams.set('variant', v.id);
window.history.replaceState(null, '', u.toString());
} catch (e) {}
}
}
sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
update(false);
var dots = $$('[data-km-dot]', pdp);
if (track && dots.length) {
var raf = null;
track.addEventListener('scroll', function () {
if (raf) return;
raf = requestAnimationFrame(function () {
raf = null;
var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
});
}, { passive: true });
}
var bar = $('[data-km-sticky]');
var anchor = $('[data-km-buy]', pdp);
if (bar && anchor && 'IntersectionObserver' in window) {
new IntersectionObserver(function (entries) {
var en = entries[0];
var past = !en.isIntersecting && en.boundingClientRect.top < 0;
bar.classList.toggle('is-on', past);
document.body.classList.toggle('km-has-sticky', past);
}, { threshold: 0 }).observe(anchor);
bar.addEventListener('click', function (e) {
var b = e.target.closest('[data-km-proxy]');
if (!b) return;
var real = b.getAttribute('data-km-proxy') === 'buy' ? buy : atc;
if (real && !real.disabled) real.click();
});
}
}
function initBuilder() {
var bb = $('[data-km-bb]');
if (!bb) return;
var picks = [];
var tray = $('[data-km-bb-tray]', bb);
var picked = $('[data-km-bb-picked]', bb), sum = $('[data-km-bb-sum]', bb), addBtn = $('[data-km-bb-add]', bb);
function itemData(card) {
var sel = card.querySelector('[data-km-bb-var]');
var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
if (!opt || opt.disabled) return null;
return {
vid: Number(opt.value),
price: Number(opt.getAttribute('data-price')),
title: card.getAttribute('data-title'),
variant: opt.getAttribute('data-vtitle') || '',
img: card.getAttribute('data-img')
};
}
function paint() {
var n = picks.length;
var sub = picks.reduce(function (s, p) { return s + p.price; }, 0);
var t = CFG.mm.on ? tierFor(n) : { cur: null, next: null };
var save = t.cur ? Math.round((sub * t.cur.p) / 100) : 0;
tray.hidden = n === 0;
document.body.classList.toggle('km-has-tray', n > 0);
picked.innerHTML = picks.map(function (p, i) {
return '<div class="km-bb__thumb"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="46" height="46">' +
'<button type="button" data-km-bb-rm="' + i + '" aria-label="Remove ' + esc(p.title) + '">&times;</button></div>';
}).join('');
var line = '<b>' + n + ' ' + plural(n, 'item', 'items') + '</b> ' +
(save ? '<s>' + money(sub) + '</s> <b>' + money(sub - save) + '</b> with ' + t.cur.p + '% off' : money(sub));
if (t.next) line += '<br>Add ' + (t.next.q - n) + ' more for ' + t.next.p + '% off';
sum.innerHTML = line;
addBtn.disabled = n === 0;
$$('[data-km-tier]', bb).forEach(function (el) {
el.classList.toggle('is-on', !!t.cur && Number(el.getAttribute('data-km-tier')) === t.cur.q);
});
}
bb.addEventListener('click', function (e) {
var el;
if ((el = e.target.closest('[data-km-bb-pick]'))) {
var d = itemData(el.closest('[data-km-bb-item]'));
if (!d) { toast('That size is sold out.'); return; }
picks.push(d);
var lab = el.textContent;
el.textContent = 'Added';
setTimeout(function () { el.textContent = lab; }, 900);
paint();
return;
}
if ((el = e.target.closest('[data-km-bb-rm]'))) { picks.splice(Number(el.getAttribute('data-km-bb-rm')), 1); paint(); return; }
if ((el = e.target.closest('[data-km-bb-preset]'))) {
var handles = el.getAttribute('data-km-bb-preset').split(',');
picks = [];
handles.forEach(function (h) {
var card = bb.querySelector('[data-km-bb-item][data-handle="' + h.trim() + '"]');
var d = card && itemData(card);
if (d) picks.push(d);
});
paint();
if (!picks.length) toast('Those items are sold out right now.');
return;
}
if ((el = e.target.closest('[data-km-bb-add]'))) {
var map = {};
picks.forEach(function (p) { map[p.vid] = (map[p.vid] || 0) + 1; });
var items = Object.keys(map).map(function (k) { return { id: Number(k), quantity: map[k] }; });
addItems(items, el, false).then(function () { picks = []; paint(); });
}
});
paint();
}
function boot() {
initMixMatch();
initProduct();
initBuilder();
Cart.get().then(render).catch(function () {});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.get().then(render).catch(function () {}); });
})();